<div class="page-help-business">

    <div class="business-card help-card">

        <div class="card-header">
            <div class="card-header-left">
                <i class="fal fa-headset card-icon"></i>
                <h3 class="card-title">Contacta con nosotros</h3>
            </div>
        </div>

        <div class="card-body">
            <p class="subtitle-help-business">Estamos disponibles para resolver cualquier duda.</p>

            <div class="help-contact-cards">
                <a href="tel:+34941135052" class="contact-card">
                    <div class="contact-card-icon">
                        <i class="fal fa-phone"></i>
                    </div>
                    <div>
                        <p class="m-0 title-contact">Teléfono de atención</p>
                        <p class="m-0 info-contact">941 135 052</p>
                    </div>
                </a>

                <a href="mailto:hola@citylok.com" class="contact-card">
                    <div class="contact-card-icon">
                        <i class="fal fa-envelope"></i>
                    </div>
                    <div>
                        <p class="m-0 title-contact">Email de contacto</p>
                        <p class="m-0 info-contact">hola&#64;citylok.com</p>
                    </div>
                </a>
            </div>

            <div class="btn-create m-0 mt-2" (click)="openContactBusiness()">
                <i class="fal fa-paper-plane"></i>
                <p class="m-0">Enviar mensaje</p>
            </div>
        </div>

    </div>

</div>
